const ShareInputArea = ({ currentUser, onOpenModal }) => {
    const profilePicUrl = currentUser?.profilePic
        ? (currentUser.profilePic.startsWith("http") ? currentUser.profilePic : "/upload/" + currentUser.profilePic)
        : "/public/noAvatar.png";

    return (
        <div className="top">
            <div className="left">
                <img 
                    src={profilePicUrl} 
                    alt={currentUser?.name || "User"} 
                />

                <div 
                    className="inputFake" 
                    onClick={onOpenModal}
                >
                    {`What's on your mind ${currentUser?.name}?`}
                </div>
            </div>
        </div>
    );
};

export default ShareInputArea;